import { takeEvery, call, select } from 'redux-saga/effects'
import { trackEvent } from '@offerzen/pinata-shame'
import { errorHandler } from '../helpers/errorHelpers'
import * as analyticsView from '../reducks/analytics'
import { userRole } from '../selectors/currentUser'

function* trackEventSaga({ meta }) {
  try {
    const role = yield select(userRole)
    yield call(trackEvent, meta.name, { ...meta.data, role })
  } catch (err) {
    yield call(errorHandler, err)
  }
}

export default function* watchAnalyticsSagas() {
  yield takeEvery(analyticsView.TRACK_EVENT, trackEventSaga)
}
